import { useTranslation } from '@/src/i18n';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

export interface SocialStatsBarProps {
  followersCount: number;
  followingCount: number;
  friendsCount: number;
  onFollowersPress: () => void;
  onFollowingPress: () => void;
  onFriendsPress: () => void;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
  };
}

export const SocialStatsBar = ({
  followersCount,
  followingCount,
  friendsCount,
  onFollowersPress,
  onFollowingPress,
  onFriendsPress,
  colors,
}: SocialStatsBarProps) => {
  const { t } = useTranslation();

  return (
    <View style={[styles.container, { backgroundColor: colors.card, borderColor: colors.border }]}>
      <TouchableOpacity style={styles.stat} onPress={onFollowersPress} activeOpacity={0.7}>
        <Text style={[styles.count, { color: colors.text }]}>{followersCount}</Text>
        <Text style={[styles.label, { color: colors.textSecondary }]}>{t('social.followers')}</Text>
      </TouchableOpacity>

      <View style={[styles.divider, { backgroundColor: colors.border }]} />

      <TouchableOpacity style={styles.stat} onPress={onFollowingPress} activeOpacity={0.7}>
        <Text style={[styles.count, { color: colors.text }]}>{followingCount}</Text>
        <Text style={[styles.label, { color: colors.textSecondary }]}>{t('social.following')}</Text>
      </TouchableOpacity>

      <View style={[styles.divider, { backgroundColor: colors.border }]} />

      <TouchableOpacity style={styles.stat} onPress={onFriendsPress} activeOpacity={0.7}>
        <Text style={[styles.count, { color: colors.text }]}>{friendsCount}</Text>
        <Text style={[styles.label, { color: colors.textSecondary }]}>{t('social.friends')}</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: 10,
    borderRadius: 10,
    borderWidth: 1,
    marginVertical: 10,
  },
  stat: {
    alignItems: 'center',
    flex: 1,
  },
  count: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 2,
  },
  label: {
    fontSize: 12,
  },
  divider: {
    width: 1,
    height: 28,
  },
});
